import { Provider } from '@radix-ui/react-tooltip';
import React from 'react';

import { TooltipProviderProps } from './Tooltip.types';

export function TooltipProvider(props: TooltipProviderProps & { children: React.ReactNode }) {
  return <Provider {...props} />;
}
